import { getAppApiRoutes } from "../../Global";
import { TerminalAccessoryFilterRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class TerminalAccessoryService {
  async getTerminalAccessories(data: TerminalAccessoryFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminalAccessory.getTerminalAccessory, { orderBy: "createdAt_desc", filter: data });
  }
}

const service: TerminalAccessoryService = new TerminalAccessoryService();
export default service;
